import React, { Component } from 'react'
import SectionTitle from '../SectionTitle'


export class ServiceTwoVps extends Component {
    render() {
        var ServiceData = this.props.ServiceData;

        return (
            <section className="services-wrap service-two section-padding-ssl pt-0" id="service">
                <div className="container">

                <SectionTitle Title="All Virtual Servers Included"  Titlep="" />

                    <div className="row">
                    {
                        ServiceData.serviceBoxItem.map( (item, index) =>  {
                            return(
                                index < 9 ? 
                                <div className="col-lg-4 col-md-6 col-12" key={item.id} >
                                    <div className="service-box-2 servicev3" data-aos="fade-up" data-aos-duration={1000}>
                                        <div className="service-icon">
                                            <img src={require (`../../assets/img/services-2/${item.imgUrl}`)} alt="klaud" />
                                        </div>
                                        <h4>{item.title}</h4>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                                :
                                ''
                            )                            
                        })
                    }
                    </div>
                </div>
            </section>
        )
    }
}

export default ServiceTwoVps
